/******************************************************************************\
 * :$
 *
 * Copyright(c) 2022 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: SystemProjectJson
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 15Dec2022 craig File created.
 \******************************************************************************/
import React, {Fragment, useMemo, useState} from "react";
import {ISystemUrl} from "../../../models/admin/ISystem";
import {ISubmission} from "../../../models/application/IApplication";
import {useRequest} from "../../../helper/useRequest";
import {Container, Row} from "react-bootstrap";
import {useParams} from "react-router-dom";
import {IOutcome} from "../../../models/request/Outcome";

export const SystemProjectJson: React.FC = () => {
    const {days} = useParams();
    const [outcome, setOutcome] = useState<IOutcome>();

    const systemURL = process.env.REACT_APP_API_URL + "/api/admin/system/processjson/" + days;

    const [requestState, getSystemData] = useRequest({url: systemURL, initialIsLoading: true,});
    const {isLoading, data, error} = requestState;

    useMemo(() => {
        getSystemData();
    }, [])

    useMemo(() => {
        if (data != null) {
            setOutcome(data);
        }
    },[data])

    const buildProcessedJson = () => {
        let outcomeStatus: string = "Failed";
        if (outcome?.Success) {
            outcomeStatus = "Success";
        }
        return (
            <Container fluid>
                <h2>Results</h2>
                <Row>{outcome?.RequestMsg}</Row>
            </Container>
        )
    }

    return (
        <Fragment>
            {isLoading && <p>Loading ...</p>}
            {error && <p>Error</p>}
            {data && buildProcessedJson()}
        </Fragment>
    );

}